const tempGroupRuleValidate = {
  name: [{ required: true, message: '模版组名称不能为空', trigger: 'blur' }],
  sort: [{ required: true, type: 'number', message: '排序不能为空', trigger: 'blur' }]
};
export { tempGroupRuleValidate };
